export const formatBRL = (priceCents) =>
  (Number(priceCents) / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

export default formatBRL;
